import React, { Suspense, lazy } from 'react';
import { Box, Skeleton } from '@chakra-ui/react';

interface Props {
  initialValue?: string;
  placeholder?: string;
  onChange?: (content: string) => void;
}

const TextEditorImpl = lazy(() => import('./text-editor-impl'));

const TextEditor: React.FC<Props> = (props) => {
  return (
    <Suspense
      fallback={
        <Box mb={4} position="relative" width="100%">
          <Skeleton height="140px" borderRadius="0.375rem" />
        </Box>
      }
    >
      <TextEditorImpl {...props} />
    </Suspense>
  );
};

export default TextEditor;
